import {
  Navigate,
  Route,
  Routes,
} from "react-router-dom";


import PublicOfferPage
  from "../modules/public-offer/pages/PublicOfferPage";

import PublicOfferPaymentPage
  from "../modules/public-offer/pages/PublicOfferPaymentPage";

import PublicOfferSuccessPage
  from "../modules/public-offer/pages/PublicOfferSuccessPage";


const PublicOfferRoutes = () => {

  return (
    <Routes>

      {/*
      |--------------------------------------------------------------------------
      | VIEW PUBLIC OFFER
      |--------------------------------------------------------------------------
      |
      | Example:
      |
      | /offer/8a7f3c...
      |
      */}

      <Route
        path="/offer/:token"
        element={
          <PublicOfferPage />
        }
      />


      {/*
      |--------------------------------------------------------------------------
      | PUBLIC OFFER PAYMENT
      |--------------------------------------------------------------------------
      |
      | Example:
      |
      | /offer/8a7f3c.../payment
      |
      */}

      <Route
        path="/offer/:token/payment"
        element={
          <PublicOfferPaymentPage />
        }
      />


      {/*
      |--------------------------------------------------------------------------
      | PUBLIC OFFER SUCCESS
      |--------------------------------------------------------------------------
      |
      | Example:
      |
      | /offer/8a7f3c.../success
      |
      */}

      <Route
        path="/offer/:token/success"
        element={
          <PublicOfferSuccessPage />
        }
      />


      {/*
      |--------------------------------------------------------------------------
      | UNKNOWN PUBLIC OFFER ROUTE
      |--------------------------------------------------------------------------
      */}

      <Route
        path="*"
        element={
          <Navigate
            to="/"
            replace
          />
        }
      />

    </Routes>
  );

};


export default PublicOfferRoutes;
